// Keep only the two service destinations generated by the SMS service.
const SMS_LINK_KEY = 'saan.sms.destination';
export function parseSMSLink(value) {
  if (typeof value !== 'string') return null;
  const match = value.match(/^(\/client\/visits\/[1-9][0-9]*|\/visitDetail\/[1-9][0-9]*)\?p=([1-9][0-9]*)$/);
  if (!match || !Number.isSafeInteger(Number(match[2]))) return null;
  return { path: value, project: Number(match[2]) };
}
export function rememberSMSLink(value) {
  if (!parseSMSLink(value)) return;
  try { window.sessionStorage.setItem(SMS_LINK_KEY, value); } catch (_) { /* storage may be unavailable */ }
}
export function pendingSMSLink() {
  try { return parseSMSLink(window.sessionStorage.getItem(SMS_LINK_KEY)); } catch (_) { return null; }
}
export function clearSMSLink() {
  try { window.sessionStorage.removeItem(SMS_LINK_KEY); } catch (_) { /* storage may be unavailable */ }
}
